import { instance } from "../api/axiosInstance";
const axios = instance;

export async function getUserRequestByType(requestType) {
	return axios.get(`/userRequests`, {
        params: {
            requestType: requestType,
        },
      });
}

export async function postUserRequestByType(body) {
	return axios.post(`/userRequests`, body);
}